(function () {
    'use strict';

    angular
        .module('app')
        .controller('ExportItemsDialogCtrl', ExportItemsDialogCtrl);

    ExportItemsDialogCtrl.$inject = ['DialogInstance', 'DialogService', 'ItemService', 'parentItemId', 'selectedNoteIds'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for choices on Item export.
     */
    function ExportItemsDialogCtrl(DialogInstance, DialogService, ItemService, parentItemId, selectedNoteIds) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.exportType = 'AllNotes';
        vm.showAdvanced = false;
        vm.includeLookups = false;
        vm.selectedNoteIds = selectedNoteIds;
        var exportUser = { Name: 'User', Selected: true };
        var exportSubject = { Name: 'Subject', Selected: true};
        var exportNote = { Name: 'Note', Selected: true };
        var exportTags = { Name: 'Tags', Selected: true };
        vm.exportFields = [exportUser, exportSubject, exportNote, exportTags];

        activate();

        function activate() {
            if (selectedNoteIds && selectedNoteIds.length > 0) {
                vm.exportType = 'SelectedNotes';
            }
        }

        function ok() {
            DialogInstance.ok({
                IncludeLookups: vm.includeLookups,
                ExportType: vm.exportType,
                NotesParentId: parentItemId,
                SelectedNotes: selectedNoteIds,
                ExportUser: exportUser.Selected,
                ExportSubject: exportSubject.Selected,
                ExportNote: exportNote.Selected,
                ExportTags: exportTags.Selected
            });
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();